import { render, staticRenderFns } from "./ListPending.vue?vue&type=template&id=2f4cdfbe&"
import script from "./ListPending.vue?vue&type=script&lang=js&"
export * from "./ListPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports